// Compass bearings, in one place because two sides of the review path show them.
//
// A submission stores degrees, because degrees are precise and are what EXIF
// and a slider produce. Every surface DISPLAYS a cardinal direction, because
// nobody stands in a park thinking "215 degrees". The two must agree, so the
// conversion is shared rather than written out twice.

const NAMES = [
  "north",
  "north-east",
  "east",
  "south-east",
  "south",
  "south-west",
  "west",
  "north-west",
] as const;

/** "looking south-west". Accepts any number; negatives and over-360 wrap. */
export function cardinal(deg: number): string {
  if (!Number.isFinite(deg)) return "an unknown direction";
  const wrapped = ((deg % 360) + 360) % 360;
  return NAMES[Math.round(wrapped / 45) % 8];
}
